import LicenseSeatBadge from "@/v2-backoffice-client/license/LicenseSeatBadge"
import {
  CUSTOMER_SEAT_STATUSES,
  deriveCustomerSeatFacts,
  describeCustomerSeatFacts,
  type CustomerSeatInput,
} from "@/v2-backoffice-client/customer/license/customer.license.utils"

export type CustomerLicenseBadgeProps = {
  customer: CustomerSeatInput
  className?: string
}

/**
 * Occupied-vs-licensed seats at a glance: "8 / 5" against the seat caps of
 * the customer's live lic.Licenses rows, rendered by the shared seat badge
 * (amber when the customer occupies more seats than it pays for). Silent for
 * customers holding no license — the status badge already says "No license"
 * there. The tooltip carries the full breakdown (users vs open invitations).
 */
function CustomerLicenseBadge(props: CustomerLicenseBadgeProps) {
  const { customer, className } = props

  const facts = deriveCustomerSeatFacts(customer)

  if (facts.status === null) return null

  const isOver = facts.status === CUSTOMER_SEAT_STATUSES.OVER_LIMIT

  return (
    <LicenseSeatBadge
      className={className}
      occupied={facts.seatsUsed}
      cap={facts.licensedSeats}
      tooltip={
        <>
          <p>{describeCustomerSeatFacts(facts)}</p>
          {isOver && (
            <p className="mt-1 text-muted-foreground">
              More seats occupied than licensed — start the upsell or trim the
              seats.
            </p>
          )}
        </>
      }
    />
  )
}

export default CustomerLicenseBadge
